var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlertCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 1.83325C4.59416 1.83325 1.83325 4.59416 1.83325 7.99992C1.83325 11.4057 4.59416 14.1666 7.99992 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99992C14.1666 4.59416 11.4057 1.83325 7.99992 1.83325ZM0.833252 7.99992C0.833252 4.04188 4.04188 0.833252 7.99992 0.833252C11.958 0.833252 15.1666 4.04188 15.1666 7.99992C15.1666 11.958 11.958 15.1666 7.99992 15.1666C4.04188 15.1666 0.833252 11.958 0.833252 7.99992ZM7.99994 4.83325C8.27608 4.83325 8.49994 5.05711 8.49994 5.33325V7.99992C8.49994 8.27606 8.27608 8.49992 7.99994 8.49992C7.7238 8.49992 7.49994 8.27606 7.49994 7.99992V5.33325C7.49994 5.05711 7.7238 4.83325 7.99994 4.83325ZM7.99994 10.1667C7.7238 10.1667 7.49994 10.3906 7.49994 10.6667C7.49994 10.9429 7.7238 11.1667 7.99994 11.1667H8.00661C8.28275 11.1667 8.50661 10.9429 8.50661 10.6667C8.50661 10.3906 8.28275 10.1667 8.00661 10.1667H7.99994Z",
    fill: "#C60024"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/AlertCircle.d83877e3.svg";
export { ForwardRef as ReactComponent };